import { DetailLoading } from 'app/KinerjaKSPage/components/CardDataConfirmation/Detail/DetailLoading'
import { DetailRoot } from 'app/KinerjaKSPage/components/CardDataConfirmation/Detail/DetailRoot'
import { DetailContent } from 'app/KinerjaKSPage/components/CardDataConfirmation/Detail/DetailContent'
import { DetailContentList } from 'app/KinerjaKSPage/components/CardDataConfirmation/Detail/DetailContentList'
import { DetailContentListValue } from 'app/KinerjaKSPage/components/CardDataConfirmation/Detail/DetailContentListValue'
import { DetailCallback } from 'app/KinerjaKSPage/components/CardDataConfirmation/Detail/DetailCallback'

const Detail = {
  Root: DetailRoot,
  Loading: DetailLoading,
  Content: DetailContent,
  ContentList: DetailContentList,
  ContentListValue: DetailContentListValue,
  Callback: DetailCallback,
}

export default Detail
